module.exports = flarum.reg.get('fof-ui-kit', 'forum/components/DiscussionSearch');